import Icon from "@chakra-ui/icon";
import { Flex, Stack } from "@chakra-ui/layout";
import { FiSearch, FiTruck, FiUsers } from "react-icons/fi";
import { Caption, H4 } from 'src/typography/typography'

function UnclaimedOrgPitch({ orgId = null, ...rest }) {
  return (
    <Flex
      flexWrap={['wrap', 'wrap', 'nowrap']}
    >
      <Stack
        align='center'
        boxShadow='md'
        borderRadius='lg'
        px={6}
        py='base'
        mr={6}
        w={['100%', '100%', '33%']}
      >
        <Icon
          as={FiTruck}
        />
        <H4>
          Create and share projects
          </H4>
        <Caption>
          Put your work on Projectlink &
          quickly share it with new and existing leads
        </Caption>
      </Stack>
      <Stack
        align='center'
        boxShadow='md'
        borderRadius='lg'
        px={6}
        py='base'
        mx={6}
        w={['100%', '100%', '33%']}
      >
        <Icon
          as={FiSearch}
        />
        <H4>
          Be discovered by clients
          </H4>
        <Caption>
          We automatically recommend your work
          to companies in your market
          </Caption>
      </Stack>
      <Stack
        align='center'
        boxShadow='md'
        borderRadius='lg'
        px={6}
        py='base'
        ml={6}
        w={['100%', '100%', '33%']}
      >
        <Icon
          as={FiUsers}
        />
        <H4>
          Invite team members
          </H4>
        <Caption>
          Share and collaborate <br />
            with your team
        </Caption>
      </Stack>
    </Flex >
  )
}

export default UnclaimedOrgPitch
